"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function OurStory() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="237376" id="the-experts-authority" className="bg-secondary py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative aspect-[3/4] w-full overflow-hidden rounded-sm border border-border shadow-lg">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/engineering_drawings_new.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/engineering_drawings_new.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/engineering_drawings_new.png-wvc-sizes" alt="Engineering drawings" className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 via-transparent to-primary/5 mix-blend-multiply pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-secondary/80 lg:hidden pointer-events-none" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b-2 border-r-2 border-primary/20 hidden lg:block" />
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-4 mb-8">
              <Separator className="w-12 bg-ring" />
              <span className="text-sm font-mono tracking-widest uppercase text-primary">
                The Industry's Evaluator
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-extrabold tracking-tighter text-primary mb-8 leading-tight">
              A Trusted Authority in <span className="text-ring">Engineering</span> Standards and <span className="text-ring">Ethics</span>.
            </h2>

            <div className="space-y-6 text-lg text-foreground/80 leading-relaxed font-default">
              <p>
                Mohammed Saleem, P.E., serves as a critical pillar in the engineering community. Beyond his extensive practice, he has been appointed by the California Board of Engineers as a third-party expert to evaluate the technical integrity of complex projects.
              </p>
              <p className="font-serif italic text-2xl text-primary border-l-4 border-ring pl-6 py-2">
                "Providing opinions on the complaints filed against other engineers."
              </p>
              <p>
                With over 40 years of experience across California and Utah, Mr. Saleem brings an unparalleled depth of knowledge to every forensic evaluation and foundation correction, ensuring that safety and professional standards are never compromised.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-border flex items-center justify-between max-w-md">
              <div>
                <h3 className="text-xl font-default font-bold text-primary">Mohammed Saleem, P.E.</h3>
                <p className="text-sm font-mono text-muted-foreground mt-1 uppercase tracking-wider">Managing Member & Expert Witness</p>
              </div>
              <div className="h-16 w-32 relative opacity-90">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/mohammed_saleem_signature.png" alt="Mohammed Saleem Signature" className="absolute inset-0 w-full h-full object-contain object-right" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}